import { HugeiconsIcon } from '@hugeicons/react';
import { Alert01Icon } from '@hugeicons/core-free-icons';
import { cn } from '@/lib/utils';
import { AUTH_MODE } from '@/config';

/**
 * Persistent badge indicating demo/simulated data.
 * Only visible when the application is running in demo mode (AUTH_MODE === 'demo').
 * In jwt/entra mode the data comes from real sources.
 */
export function DemoDataBadge({ className }) {
  if (AUTH_MODE !== 'demo') return null;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg',
        'bg-warning/10 text-warning border border-warning/20',
        'text-[11px] font-medium',
        className,
      )}
      role="status"
      aria-label="Los datos mostrados son de demostración">
      <HugeiconsIcon icon={Alert01Icon} className="h-3 w-3" aria-hidden="true" />
      <span>Datos de demostración</span>
    </div>
  );
}

/**
 * ConfidenceBadge — Displays data confidence level.
 */
export function ConfidenceBadge({ level, className }) {
  const config = {
    alto: { label: 'Alta confianza', bg: 'bg-success/10 text-success border-success/20' },
    medio: { label: 'Confianza media', bg: 'bg-warning/10 text-warning border-warning/20' },
    bajo: { label: 'Baja confianza', bg: 'bg-risk-high/10 text-risk-high border-risk-high/20' },
    estimado: { label: 'Estimado', bg: 'bg-muted text-muted-foreground border-border' },
  };

  const c = config[level?.toLowerCase()] || config.estimado;

  return (
    <span
      className={cn('inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium border', c.bg, className)}
      aria-label={c.label}>
      {c.label}
    </span>
  );
}
